"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellerProblemStatus = exports.SellerProblemType = void 0;
var SellerProblemType;
(function (SellerProblemType) {
    SellerProblemType["UNKNOWN_BARCODE"] = "UNKNOWN_BARCODE";
    SellerProblemType["MISSING_BARCODE"] = "MISSING_BARCODE";
    SellerProblemType["DAMAGED_PRODUCT"] = "DAMAGED_PRODUCT";
    SellerProblemType["UNEXPECTED_SKU"] = "UNEXPECTED_SKU";
    SellerProblemType["UNEXPECTED_SKU_V2"] = "UNEXPECTED_SKU_V2";
    SellerProblemType["INVALID_LOT_EXPIRY"] = "INVALID_LOT_EXPIRY";
    SellerProblemType["MISSING_BOXES"] = "MISSING_BOXES";
    SellerProblemType["OTHER_NON_COMPLIANCE"] = "OTHER_NON_COMPLIANCE";
    SellerProblemType["RELABELLED_BOXES"] = "RELABELLED_BOXES";
    SellerProblemType["SHORT_SHIP"] = "SHORT_SHIP";
    SellerProblemType["FLEXPORT_EXCEPTION"] = "FLEXPORT_EXCEPTION";
})(SellerProblemType = exports.SellerProblemType || (exports.SellerProblemType = {}));
var SellerProblemStatus;
(function (SellerProblemStatus) {
    SellerProblemStatus["CREATED"] = "CREATED";
    SellerProblemStatus["RESOLVED"] = "RESOLVED";
    SellerProblemStatus["ACTION_NEEDED"] = "ACTION_NEEDED";
    SellerProblemStatus["SUPPORT_CONTACTED"] = "SUPPORT_CONTACTED";
})(SellerProblemStatus = exports.SellerProblemStatus || (exports.SellerProblemStatus = {}));
//# sourceMappingURL=SellerProblemsView.js.map